import httpClient from '@/http-client'

export const createFolder = data => {
  return httpClient
    .post('/api/create-folders', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const deleteItem = data => {
  return httpClient
    .post('/api/remove', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const renameItem = data => {
  return httpClient
    .put(`/api/rename/${data.id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  createFolder,
  deleteItem,
  renameItem
}
